export default "__VITE_ASSET__Cj4unnz6__"